import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // basic styles
import "swiper/css/navigation"; // optional: navigation buttons
import "swiper/css/pagination"; // optional: pagination
import { Navigation } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import "./ProductDetail.css";
import "./ProductSlider.css";
import { BASE_URL } from "./Config";
import { useParams } from "react-router";
import axios from "axios";
import Cookies from "js-cookie";
import { FaMapMarkerAlt } from "react-icons/fa";
import { formatDistanceToNow } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CountdownTimer } from "../components/CountDownTimer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { QRCodeCanvas } from "qrcode.react";
import BuyerNamechar from "../components/BuyerNamechar";
import BuyerName from "../components/BuyerName";

import UserReviewInfo from "../components/UserReviewInfo";

export default function ProductDetail(auctionStartPrice) {
  const { id } = useParams(); // Type hinting for TypeScript
  const navigate = useNavigate();
  const [showToast, setToastMessage] = useState(false);
  const [newsItem, setNewsItem] = useState("");
  const [biditem, setbidItem] = useState("");
  const [productuserId, setProductUserId] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [BuyerId, setBuyerId] = useState("");
  const [buyId, setbuyerid] = useState("");
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [userinfo, setUserdatainfo] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [ratingText, setRatingText] = useState("");
  const [selectedBuyerId, setSelectedBuyerId] = useState();
  const [SelectedProductId, setSelectedProductId] = useState();
  const [satisfactionLevel, setSatisfactionLevel] = useState("");
  const [ratingEmoji, setRatingEmoji] = useState("");
  const [loading, setLoading] = useState(true);

  const userlogin = Cookies.get("user_id");

  // Get Login User Data
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userlogin}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          //  const userData = res.data.data[0];
          setUserdatainfo(res.data.data);
          // console.log("userdata", res.data.data);
        } else {
          //   console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, [userlogin]);

  // Get  Item Data By Id

  const fetchItemById = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/get_item_by_id.php?id=${id}&t=${Date.now()}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        const item = data.data[0];

        // ✅ Only update if data actually changed
        setNewsItem((prev) =>
          JSON.stringify(prev) !== JSON.stringify(item) ? item : prev
        );

        setSelectedBuyerId(item.user_id);
        setProductUserId(item.user_id);
        setSelectedProductId(item.id);
        setBuyerId(item.buyer_id);
      } else {
        navigate("/404", { replace: true });
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchItemById();

    const interval = setInterval(fetchItemById, 1000);

    return () => clearInterval(interval);
  }, [id]);

  const fetchItemByIdbid = async (itemId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/get_item_by_id.php?id=${id}&t=${Date.now()}`
      );
      const data = await response.json();

      //  console.log("dataa", data);
      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        const item = data.data[0];
        setbidItem(item);

        //  console.log("bid value :", item);

        setProductUserId(item.user_id);

        setBuyerId(item.buyer_id);

        const bid =
          Number(item.current_price) > 0
            ? Number(item.current_price)
            : Number(item.auction_start_price);

        setCurrentBid(bid);
      } else {
        console.warn("Item not found or response failed:", data);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  useEffect(() => {
    fetchItemByIdbid();
  }, []);

  useEffect(() => {
    if (!BuyerId) return; // Wait until BuyerId is available

    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${BuyerId}`)
      .then((res) => {
        //   console.log("API response:", res.data.data);
        if (res.data.success) {
          setbuyerid(res.data.data);
        } else {
          //   console.warn("API call failed:", res.data.message);
        }
      })
      .catch((err) => {
        console.error("API request failed:", err);
      });
  }, [BuyerId]); // ✅ Add BuyerId to dependency array

  // console.log("buyer data :", buyId);

  useEffect(() => {
    if (!id) return;

    const interval = setInterval(() => {
      fetchItemById(id);
    }, 100);

    return () => clearInterval(interval);
  }, [id]);

  const imageList = (() => {
    let photos = [];

    // if (newsItem.main_image) {
    //   photos.push(newsItem.main_image); // add main image first
    // }

    if (newsItem.photo) {
      try {
        if (Array.isArray(newsItem.photo)) {
          photos = [...photos, ...newsItem.photo];
        } else {
          const parsed = JSON.parse(newsItem.photo);
          if (Array.isArray(parsed)) {
            photos = [...photos, ...parsed];
          }
        }
      } catch {
        // comma separated fallback
        photos = [...photos, ...newsItem.photo.split(",")];
      }
    }

    return photos;
  })();

  const [quantity, setQuantity] = useState();

  let setbid;
  if (newsItem.current_price <= 50) {
    setbid = 1;
  } else if (newsItem.current_price <= 1000) {
    setbid = 5;
  } else {
    setbid = 10;
  }

  let lessbid = setbid; // same logic, no need to repeat

  const handleIncrease = () => {
    setQuantity((prev) => Number(prev) + setbid);
  };

  const handleDecrease = () => {
    setQuantity((prev) => {
      const minBid = Number(newsItem.current_price);
      const newQty = Number(prev) - lessbid;

      console.log("Current Quantity:", prev);
      console.log("Current Bid (Min Allowed):", minBid);
      console.log("New Quantity after -", lessbid, ":", newQty);

      if (newQty >= minBid) {
        return newQty;
      } else {
        console.log("Cannot decrease below current bid");
        return prev;
      }
    });
  };

  const [selectedButton, setSelectedButton] = useState("data1");

  const [userdata, setUserdata] = useState([]);

  const userId = Cookies.get("user_id");
  const userIdLogin = Cookies.get("user_id");
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userId}`)
      .then((res) => {
        //   console.log("API response:", res.data.data); // Check the full response
        if (res.data.success) {
          setUserdata(res.data.data);
          // console.log(res.data.data);
        } else {
          //    console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => {
        console.error("API request failed:", err);
        if (err.response) {
          console.error("Response error:", err.response);
        } else if (err.request) {
          console.error("No response received:", err.request);
        } else {
          console.error("Request setup error:", err.message);
        }
      });
  }, []);

  useEffect(() => {
    if (biditem) {
      const price = parseInt(
        biditem.current_price || biditem.auction_start_price,
        10
      );
      if (!isNaN(price)) {
        setQuantity(price);
      }
    }
  }, [biditem]);

  // console.log("bid value ", biditem);

  const user_id = Cookies.get("user_id");
  const [currentBid, setCurrentBid] = useState(Number(quantity));

  const [loadingplacebid, setLoadingplacebid] = useState(false);

  const placeBid = async () => {
    // show loader
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    if (userinfo.status == 0) {
      toast.warning("Your Account is suspended !");
      setLoadingplacebid(false);
      return;
    }

    if (Number(user_id) === Number(newsItem.user_id)) {
      toast.warning("You Can't Bid On your Product !");
      setLoadingplacebid(false);
      return;
    }

    if (Number(quantity) <= Number(newsItem.current_price)) {
      toast.warning("Increase Bid Amount !");
      setLoadingplacebid(false);
      return;
    }

    setLoadingplacebid(true);
    try {
      const response = await axios.post(`${BASE_URL}/user_bid.php`, {
        productId: id,
        userAmount: quantity,
        userId: user_id,
      });

      console.log("placebid :", response);

      if (response.data.success) {
        toast.success("Bid placed successfully !", { toastId: "bid-success" });

        const buyer_user_id = Cookies.get("user_id");
        const data = {
          product_id: id,
          userAmount: currentBid,
          product_user_id: user_id,
          buyer_user_id: buyer_user_id,
        };

        try {
          const res = await axios.post(
            `${BASE_URL}/relist_request.php?type=bid`,
            data,
            { headers: { "Content-Type": "application/json" } }
          );

          if (res.data.success) console.log("Relist bid success");
          else console.log("Relist bid error");

          const rescheck = await axios.post(
            `${BASE_URL}/relist_request.php?type=check`,
            data,
            { headers: { "Content-Type": "application/json" } }
          );

          if (rescheck.data.success) console.log("Relist check success");
          else console.log("Relist check error");
        } catch (error) {
          console.error(error);
          setToastMessage("Server error. Try again.");
        }

        fetchItemById(id);
        fetchItemByIdbid(id);
      } else {
        toast.error("Bid Not placed !");
      }
    } catch (error) {
      console.error("Error placing bid:", error);
    } finally {
      setLoadingplacebid(false); // hide loader
    }
  };

  const [itemuserdetail, setItemUser] = useState("");
  useEffect(() => {
    const fetchUserData = async () => {
      const userId = productuserId;
      // console.log("User ID from Product:", userId);

      if (!userId) return;

      try {
        const response = await axios.get(
          `${BASE_URL}/get_user_by_id.php?id=${userId}&t=${Date.now()}`
        );
        // console.log(response);
        if (response.data.success) {
          setItemUser(response.data.data);
          //    console.log("User data:", response.data.data);
        } else {
          console.error("User not found:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    fetchUserData(); // Call the async function inside useEffect
  }, [productuserId]);

  // console.log("u", itemuserdetail);

  const [question, setQuestion] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  // console.log(question);
  const questionsubmit = async (e) => {
    e.preventDefault(); // Prevent page reload

    const formData = {
      question: question,
      product_id: id,
      question_for_seller: newsItem.user_id,
      question_for_buyer: user_id,
    };

    setShowLoading(true);
    console.log(formData);

    try {
      const res = await axios.post(
        `${BASE_URL}/submit_question.php?type=buyer`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log(res);
      const data = res.data; // axios auto-parses JSON response

      console.log(data);
      if (data.success) {
        toast.success("Question Submitted Successfully! ");
        console.log(data);
        setQuestion("");
        setShowLoading(false);
        fetchQuestions();
        setShowTextarea(!showTextarea);
      } else {
        toast.warning("Login Required !");
        setShowLoading(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong, Try Again !");
      setShowLoading(false);
    }
  };
  const [buyLoading, setBuyLoadings] = useState(false);
  const buyitem = async (e) => {
    e.preventDefault();

    const user_id = Cookies.get("user_id");
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    if (userinfo.status == 0) {
      toast.warning("Your Account is suspended !");
      console.log("Your Account is suspended !");
      return;
    }

    // 1. Ask for confirmation first and wait
    const result = await Swal.fire({
      title: "Confirm Buy Now ?",

      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, buy it!",
    });

    if (!result.isConfirmed) {
      return; // stop if user cancels
    }

    if (!user_id) {
      toast.error("Login Required!");
      setBuyLoadings(false);
      return;
    }

    try {
      const res = await fetch(
        `${BASE_URL}/buy_product.php?user_id=${user_id}&product_id=${id}&t=${Date.now()}`,
        { cache: "no-store" }
      );
      const data = await res.json();

      if (data.success) {
        // ✅ Apply Charges
        const charges_apply = await axios.post(
          `${BASE_URL}/charges_apply.php?user_id=${user_id}&product_id=${id}`
        );

        if (charges_apply.data.success) {
          console.log("✅ Charges Applied");
        } else {
          console.log("❌ Charges Error:", charges_apply.data.message);
        }

        Swal.fire({
          title: "🎉 You Won!",
          text: "Congratulations on winning the auction!",
          icon: "success",
          timer: 2500, // auto close after 2.5 seconds
          showConfirmButton: false,
          timerProgressBar: true,
        });

        // 🔁 Relist Request
        const rescheck = await axios.post(
          `${BASE_URL}/relist_request.php?type=buy`,
          {
            user_id,
            product_id: id,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (rescheck.data.success) {
          console.log("🔁 Relist successful");
        } else {
          console.log("⚠️ Relist failed:", rescheck.data.message);
        }

        if (newsItem.buy_now >= 1000) {
          // ✅ Show success message at the end

          await Swal.fire({
            title: "Congratulations 🎉!",
            text: "You won this product.",
            icon: "success",
          });
        } else {
          // ✅ Show success message at the end
          await Swal.fire({
            title: "Congratulations 🎉!",
            text: "You won this product.",
            icon: "success",
          });
        }

        // setShowModal(true);
      } else {
        toast.error(data.message || "Failed to buy", { autoClose: 3000 });
      }
    } catch (err) {
      console.error("❗ Error in buyitem():", err);
      toast.error("Unexpected error", { autoClose: 3000 });
    } finally {
      setBuyLoadings(false);
    }
  };

  const [questions, setQuestions] = useState([]);

  const fetchQuestions = async () => {
    const user_id = Cookies.get("user_id");

    try {
      const res = await fetch(
        `${BASE_URL}/get_user_question.php?user_id=${user_id}&product_id=${id}&t=${Date.now()}`,
        {
          cache: "no-store",
        }
      );
      const text = await res.text();

      const data = JSON.parse(text);
      if (data.success) {
        setQuestions(data.data); // set only the questions array
        //  console.log(data.data);
      } else {
        console.log("Error:", data.message);
      }
    } catch (err) {
      console.error("Invalid JSON:", err);
    }
  };
  useEffect(() => {
    fetchQuestions();
  }, []);

  const [showTextarea, setShowTextarea] = useState(false);

  const [NewADD, setNewADD] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true); // Start loading

        const response = await axios.get(
          `${BASE_URL}/all_items.php?t=${Date.now()}`
        );

        if (response.data.success) {
          const now = new Date();

          // 1. Filter out expired products
          let filtered = response.data.data.filter((product) => {
            const closingTime = new Date(product.closing_time);
            return closingTime > now;
          });

          // 2. Filter by category id
          if (newsItem?.category) {
            filtered = filtered.filter(
              (product) => product.category === newsItem.category
            );
          }

          setNewADD(filtered);
        } else {
          setNewADD([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setNewADD([]);
      } finally {
        setLoading(false); // Always stop loading
      }
    };

    if (newsItem?.category) {
      fetchProducts();
    }
  }, [newsItem?.category]); // Add dependency

  const [userbid, setuserBid] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const userId = Cookies.get("user_id");

      if (!userId) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/all_buying_user_item.php?id=${userId}&t=${Date.now()}`
        );

        //   console.log("API response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setuserBid(response.data.data);

          // const matchedProduct = allBids.find(
          //   (item) => item.product_id === id || item.item_id === id
          // );

          // setCurrentProduct(matchedProduct || null);
        } else {
          console.error("Unexpected API structure");
          setuserBid([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setuserBid([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // console.log("userbid", userbid);

  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState([]);

  useEffect(() => {
    if (!newsItem?.user_id) return;

    const fetchUserAndReviews = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_review.php?id=${newsItem.user_id}&t=${Date.now()}`
        );
        // console.log("response", res);
        if (res.data.success) {
          setReviews(res.data.reviews);
          setRating(res.data.rating_stats);
          //   console.log("ratings", res.data.rating_stats);
        } else {
          console.error("User or reviews not found");
        }
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchUserAndReviews();
  }, [newsItem?.user_id]);

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? imageList.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === imageList.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const [bookmarks, setBookmarks] = useState([]);

  const username = Cookies.get("username");

  const fetchBookmarks = async () => {
    if (!user_id) {
      // console.error("User ID not found in cookies.");

      return;
    }
    try {
      const res = await fetch(
        `${BASE_URL}/all_fav_item.php?id=${user_id}&t=${Date.now()}`,
        {
          cache: "no-store",
        }
      );

      //  console.log(res);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      //   console.log("Fetched data:", data);

      if (data.success) {
        setBookmarks(data.data);
      } else {
        setBookmarks([]);
      }
    } catch (err) {
      console.error("Error fetching bookmarks:", err);
    }
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const [favloading, setfavloading] = useState(false);
  const addToFavorite = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    if (!id) {
      alert("Invalid id or type");
      return;
    }

    setfavloading((prev) => ({ ...prev, [id]: true }));

    const response = {
      id: id,
      username: username,
      user_id: user_id,
    };
    // console.log("Sending data:", response);
    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=add`,
        response,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // console.log(res);
      if (res.data.success) {
        // setToastMessage(res.data.message || "Added!");
        toast.success("Add To wishList !");

        fetchBookmarks();
      } else {
        //setToastMessage(res.data.message);
        toast.warning(res.data.message);
        //  setToastStatus(true);
      }

      setfavloading(false);
    } catch (error) {
      console.error(error);
      // setToastMessage("Server error. Try again.");
      setfavloading(false);
    }

    //  setToastStatus(false);
  };

  const removefav = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    if (!id || !user_id) {
      alert("Invalid id or type");
      return;
    }

    setfavloading((prev) => ({ ...prev, [id]: true }));
    const response = {
      id,
      username,
      user_id,
    };

    // console.log(response);

    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=remove`,
        response
      );

      // console.log(res);
      if (res.data.success) {
        toast.error("Removed from favorites!");
        // Refresh bookmarks list
        // const updatedRes = await fetch(
        //   `${BASE_URL}/get_favorites.php?user_id=${user_id}&t=${Date.now()}`
        // );
        // const updatedData = await updatedRes.json();
        // setBookmarks(updatedData.success ? updatedData.data : []);
        fetchBookmarks();
      } else {
        toast.error("Something went wrong.");
        // setToastStatus(true);
      }

      setfavloading(false);
    } catch (error) {
      console.error(error);
      toast.success("Server error. Try again.");
      setfavloading(false);
    }

    //  setToastStatus(false);
  };

  const product = {
    id: newsItem.id,
    title: newsItem.title,
    description: newsItem.description,
    imageUrl: `${BASE_URL}/${newsItem.photo?.split(",")[0]?.trim() || "logo/icon.png"
      }`,
  };

  const qrRef = useRef(null);

  const handleDownload = () => {
    const qrCanvas = qrRef.current?.querySelector("canvas");
    if (!qrCanvas) {
      alert("QR code not found");
      return;
    }

    /* 🔹 QR IMAGE */
    const qrImage = new Image();
    qrImage.src = qrCanvas.toDataURL("image/png");

    qrImage.onload = () => {
      /* 🔹 PRODUCT IMAGE */
      const productImg = new Image();
      productImg.crossOrigin = "anonymous";
      productImg.src = product.imageUrl;

      productImg.onerror = () => {
        productImg.src = `${BASE_URL}/uploads/logo/icon.png`;
      };

      /* 🔹 LOGO IMAGE */
      const logoImg = new Image();
      logoImg.crossOrigin = "anonymous";
      logoImg.src = `${BASE_URL}/uploads/logo/icon.png`;

      productImg.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 600;
        canvas.height = 950;

        /* 🔹 BACKGROUND */
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        /* 🔹 HEADER */
        ctx.fillStyle = "#FFD700";
        ctx.fillRect(0, 0, canvas.width, 50);

        ctx.fillStyle = "#000";
        ctx.font = "bold 25px Arial";
        ctx.textAlign = "left";
        ctx.fillText("FOR SALE", 20, 35);

        /* 🔹 TITLE */
        ctx.fillStyle = "#007bff";
        ctx.font = "bold 26px Arial";
        ctx.textAlign = "center";
        ctx.fillText(product.title || "Item Title", canvas.width / 2, 95);

        /* 🔹 PRODUCT IMAGE (object-fit: contain) */
        const boxW = 310;
        const boxH = 310;
        const boxX = (canvas.width - boxW) / 2;
        const boxY = 130;

        // Image box background
        ctx.fillStyle = "#f8f8f8";
        ctx.fillRect(boxX, boxY, boxW, boxH);

        // Border
        ctx.strokeStyle = "#ccc";
        ctx.strokeRect(boxX, boxY, boxW, boxH);

        // Contain calculation
        const imgRatio = productImg.width / productImg.height;
        const boxRatio = boxW / boxH;

        let drawW, drawH, drawX, drawY;

        if (imgRatio > boxRatio) {
          drawW = boxW;
          drawH = boxW / imgRatio;
          drawX = boxX;
          drawY = boxY + (boxH - drawH) / 2;
        } else {
          drawH = boxH;
          drawW = boxH * imgRatio;
          drawX = boxX + (boxW - drawW) / 2;
          drawY = boxY;
        }

        ctx.drawImage(productImg, drawX, drawY, drawW, drawH);

        /* 🔹 PRODUCT TYPE */
        const productTypeText =
          newsItem.product_type === "used" ? "Used" : "Not Used";

        ctx.fillStyle = "#000";
        ctx.font = "bold 20px Arial";
        ctx.textAlign = "center";
        ctx.fillText(
          `Product Type: ${productTypeText}`,
          canvas.width / 2,
          boxY + boxH + 40
        );

        /* 🔹 DESCRIPTION */
        ctx.font = "16px Arial";
        const descLines = wrapText(
          ctx,
          product.description || "No description available",
          480
        );

        descLines.forEach((line, i) => {
          ctx.fillText(
            line,
            canvas.width / 2,
            boxY + boxH + 80 + i * 22
          );
        });

        /* 🔹 LOGO (BOTTOM LEFT) */
        logoImg.onload = () => {
          const logoSize = 100;
          ctx.drawImage(
            logoImg,
            30,
            canvas.height - logoSize - 30,
            logoSize,
            logoSize
          );

          /* 🔹 QR CODE (BOTTOM RIGHT) */
          const qrSize = 150;
          const qrX = canvas.width - qrSize - 30;
          const qrY = canvas.height - qrSize - 30;

          ctx.strokeStyle = "#aaa";
          ctx.strokeRect(qrX - 8, qrY - 8, qrSize + 16, qrSize + 16);
          ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

          /* 🔹 QR TEXT */
          ctx.font = "14px Arial";
          ctx.fillStyle = "#555";
          ctx.textAlign = "center";
          ctx.fillText(
            "Scan to view product",
            qrX + qrSize / 2,
            qrY + qrSize + 20
          );

          /* 🔹 DOWNLOAD */
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `ProductQR_${product.id || "QR"}.png`;
          link.click();
        };
      };
    };
  };


  /* 🔹 TEXT WRAP HELPER */
  function wrapText(ctx, text, maxWidth) {
    const words = text.split(" ");
    let line = "";
    const lines = [];

    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      if (ctx.measureText(testLine).width > maxWidth && i > 0) {
        lines.push(line);
        line = words[i] + " ";
      } else {
        line = testLine;
      }
    }

    lines.push(line);
    return lines;
  }

  const [BuyNow, setBuyNowlimit] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_company_detail.php?type=buy_now&t=${Date.now()}`)
      .then((res) => {
        //  console.log("Full responsessdfdf:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setBuyNowlimit(res.data.data[0].number);
        } else {
          console.warn("API success true, but data is not array");
          setBuyNowlimit([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setBuyNowlimit([]);
      });
  }, []);

  // console.log("BUy Now Price lImit :", BuyNow);

  //  Zoom Function on Image  Start Here
  const [zoomed, setZoomed] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");

  const handleClick = () => {
    setZoomed((prev) => !prev);
  };

  const handleMouseMove = (e) => {
    if (!zoomed) return;
    const rect = e.target.getBoundingClientRect();
    const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
    setOrigin(`${xPercent}% ${yPercent}%`);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_rating_emoji.php?t=${Date.now()}`)
      .then((res) => {
        //  console.log("Full responsessdfdf:", res.data);

        if (res.data.success && Array.isArray(res.data.data)) {
          setRatingEmoji(res.data.data[0]);
        } else {
          setRatingEmoji([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch rating emojis", err);
        setRatingEmoji([]);
      });
  }, []);

  useEffect(() => {
    // ✅ this will log when ratingEmoji changes
    //  console.log("emoji updated:", ratingEmoji);
  }, [ratingEmoji]);

  const [ratingWord, setRatingword] = useState("");
  const fetchNegativeWords = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/get_rating_negative_word.php?t=${Date.now()}`
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setRatingword(response.data.data);
      } else {
        setRatingword([]);
      }
    } catch (error) {
      console.error("Failed to fetch bids", error);
      setRatingword([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNegativeWords();
  }, []);

  const [badWordError, setBadWordError] = useState("");
  const handleSubmitRating = async () => {
    if (!selectedBuyerId) {
      alert("Buyer ID is missing.");
      return;
    }

    if (!satisfactionLevel) {
      alert("Please select your level of satisfaction.");
      return;
    }

    const trimmedText = ratingText.trim();

    // Check for bad words if ratingWord has data
    if (ratingWord.length > 0 && ratingWord[0].words) {
      const wordList = ratingWord[0].words
        .split(",")
        .map((word) => word.trim().toLowerCase())
        .filter((word) => word !== "");

      const lowerText = trimmedText.toLowerCase();
      const foundWord = wordList.find((word) => lowerText.includes(word));

      if (foundWord) {
        setBadWordError(
          `Your feedback contains a restricted word: "${foundWord}"`
        );
        return;
      } else {
        setBadWordError(""); // clear previous error
      }
    }

    // Log all values
    console.log("Submitting Rating with the following data:");
    console.log("massage_sender (userId):", userId);
    console.log("product_id:", SelectedProductId);
    console.log("seller_id:", selectedBuyerId);
    console.log("satisfaction:", satisfactionLevel);
    console.log("message:", trimmedText);

    try {
      const res = await axios.post(`${BASE_URL}/submit_buyer_rating.php`, {
        massage_sender: userId,
        product_id: SelectedProductId,
        buyer_id: selectedBuyerId,
        satisfaction: satisfactionLevel,
        message: trimmedText,
      });

      console.log(res);

      if (res.data.success) {
        setToastMessage("Thank you for your feedback!");
      } else {
        setToastMessage("Failed to submit rating.");
      }
    } catch (err) {
      console.error("Rating error:", err);
      setToastMessage("Error submitting feedback.");
    } finally {
      setShowModal(false);
      setRatingText("");
      setSatisfactionLevel("");
      setTimeout(() => setToastMessage(""), 3000);
    }
  };

  const [relistuser, setrelistuser] = useState([]);

  // Item Get Relist Function

  const relistuserdata = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/get_relist_user.php?t=${Date.now()}`
      );

      //   console.log("Relist User", response.data);

      if (response.data.success) {
        setrelistuser(response.data);
        setLoading(false);
      } else {
        setrelistuser([]);
      }
    } catch (error) {
      console.error("Failed to fetch relist user", error);
      setrelistuser([]);
    }
  };

  useEffect(() => {
    relistuserdata();
  }, []);

  // Item Relist Function
  const relist = async (product_id: number, product_user_id: number) => {
    if (!user_id) {
      toast.warning("Login Required"); // use warning instead of success
      return;
    }

    if (userinfo.status == 0) {
      toast.warning("Your Account is suspended !");
      console.log("first");
      return;
    }

    if (product_user_id === user_id) {
      toast.warning("You can't make a request on your own product.");

      // Delay navigation to let toast show
      setTimeout(() => {
        navigate(`/list-an-item-edit/${product_id}`);
      }, 3000); // 0.5s delay

      return;
    }

    const response = {
      product_id: product_id,
      product_user_id: product_user_id,
      user_id: user_id,
    };

    // console.log("Sending data:", response);

    try {
      const res = await axios.post(`${BASE_URL}/relist_request.php`, response, {
        headers: { "Content-Type": "application/json" },
      });

      console.log(res);

      if (res.data.success) {
        toast.success(res.data.message);
        relistuserdata();
      } else {
        toast.error(res.data.message);
        relistuserdata();
      }
    } catch (error) {
      console.error(error);
      toast.error(error);
      relistuserdata();
    }
  };

  const [activeReplyId, setActiveReplyId] = useState(null); // kis question ka reply box open hai
  const [replyText, setReplyText] = useState(""); // reply text
  const [showReplyLoading, setShowReplyLoading] = useState("");

  const handleReplySubmit = async (questionId) => {
    if (!replyText.trim()) {
      toast.warning("Please enter your reply before submitting!");
      return;
    }

    console.log("Reply submitted:", replyText, "for question:", questionId);

    const formData = {
      question: replyText,
      question_id: questionId,
    };

    setShowReplyLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/submit_answer.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      console.log(res);

      const data = res.data;

      if (data.success) {
        toast.success("Replied successfully !");
        fetchQuestions();
      } else {
        setToastMessage(data.message || "Submission failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setShowReplyLoading(false);
    }

    setReplyText("");
    setActiveReplyId(null); // hide reply box
    setShowReplyLoading(false);
  };

  const handleCancel = () => {
    setReplyText("");
    setActiveReplyId(null);
  };

  const [buyNowLimit, setBuyNowLimit] = useState(0); // number instead of array

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_company_detail.php?type=buy_now&t=${Date.now()}`)
      .then((res) => {
        //  console.log("Full response:", res.data);
        if (
          res.data.success &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          setBuyNowLimit(Number(res.data.data[0].number)); // store number directly
        } else {
          console.warn("API success true, but data is not array");
          setBuyNowLimit(0);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setBuyNowLimit(0);
      });
  }, []);

  return (
    <>
      <Navbar />
      <div className="auction-details-section pt-110 mb-110">
        <div className="container-fluid">
          <div className="row gy-5">
            <div className="col-xl-7">
              <div className="auction-details-img">
                <div className="tab-content">
                  <div className="tab-pane fade show active">
                    {loading ? (
                      <Skeleton height={400} width={`100%`} />
                    ) : (
                      <div
                        className="auction-details-tab-img"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button className="slider-btn left" onClick={prevSlide}>
                          <FontAwesomeIcon icon={faArrowLeft} />
                        </button>

                        <img
                          src={`${BASE_URL}/${imageList[currentIndex]}`}
                          alt={`Slide ${currentIndex}`}
                          data-zoom-src={`${BASE_URL}/${imageList[currentIndex]}`}
                          loading="eager"
                          fetchPriority="high"
                          style={{
                            display: "block",
                            width: "100%",
                            height: "300px",
                            cursor: zoomed ? "zoom-out" : "zoom-in",
                            transform: zoomed ? "scale(2)" : "scale(1)",
                            transformOrigin: origin,
                            transition: "transform 0.2s ease-out",
                          }}
                          onClick={handleClick}
                          onMouseMove={handleMouseMove}
                          onLoad={(e) => {
                            if (window && window.firstImgLoadTime === 0) {
                              window.firstImgLoadTime = new Date().getTime();
                            }
                            if (
                              window &&
                              window.heroImg &&
                              e.target.src !== window.heroImg
                            ) {
                              e.target.src = window.heroImg;
                              window.heroImg = null;
                            }
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${BASE_URL}/uploads/logo/icon.png`;
                          }}
                        />

                        <button
                          className="slider-btn right"
                          onClick={nextSlide}
                        >
                          <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="nav nav-pills" style={{ overflow: "hidden" }}>
                  <div className="slider-container">
                    <div className="image-slider">
                      {imageList.map((img, index) => (
                        <img
                          key={index}
                          src={`${BASE_URL}/${img}`}
                          data-zoom-src={`${BASE_URL}/${img}`}
                          alt={`Thumb ${index}`}
                          loading="eager"
                          fetchPriority="high"
                          className={`thumbnail ${index === currentIndex ? "active" : ""
                            }`}
                          onMouseEnter={() => goToSlide(index)}
                          onClick={() => goToSlide(index)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5">
              {loading ? (
                <>
                  <Skeleton height={30} width={200} />
                  <Skeleton count={3} />
                </>
              ) : (
                <div
                  className="auction-details-content"
                  style={{ marginBottom: "40px" }}
                >
                  <div className="batch">
                    <span> # {newsItem.id}</span>
                  </div>
                  <h1>{newsItem.title}</h1>
                  <p>{newsItem.short_desc}</p>
                  <div
                    className="price-area"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "0",
                    }}
                  >
                    <span style={{ fontSize: "20px" }}>Product Type:</span>{" "}
                    &nbsp;
                    <strong style={{ fontSize: "13px" }}>
                      {newsItem.product_type === "used" ? "Used" : "Not Used"}
                    </strong>
                  </div>
                  <div className="price-area">
                    <span>Current Bid at: </span>
                    <strong>
                      {Number(newsItem.status) != 0 ? (
                        Number(newsItem.winner_id) != 0 ? (
                          "Bid Closed"
                        ) : new Date(newsItem.closing_time) < new Date() ? (
                          Number(newsItem.current_price) >=
                            Number(newsItem.desired_price) &&
                            Number(newsItem.current_price) != 0 ? (
                            "Target Price Reached 😊"
                          ) : (
                            <span
                              style={{
                                color: "red",
                                fontWeight: "700",
                                fontSize: "20px",
                              }}
                            >
                              😔 Price Not Met
                            </span>
                          )
                        ) : (
                          `${newsItem.current_price === ""
                            ? newsItem.auction_start_price
                            : newsItem.current_price
                          } SAR`
                        )
                      ) : (
                        ""
                      )}
                    </strong>


                    <strong>
                      {Number(newsItem.status) != 0 &&
                        Number(newsItem.winner_id) == 0 && new Date(newsItem.closing_time) > new Date() &&
                        Number(newsItem.current_price) >=
                        Number(newsItem.desired_price) &&
                        Number(newsItem.current_price) != 0 && Number(newsItem.user_id) != Number(userId) ? (

                        <span
                          style={{
                            color: "green",
                            fontWeight: "700",
                            fontSize: "14px",
                          }}
                        >
                          Target Price Reached 😊
                        </span>
                      ) :

                        newsItem.buyer_id === "0" &&
                          Number(newsItem?.winner_id) == 0 && new Date(newsItem.closing_time) <= new Date() ?


                          <>

                            <p style={{ fontSize: "16px", }}>

                              <strong style={{ fontSize: "16px", }}>Closed On:</strong>{" "}
                              {new Date(newsItem.closing_time).toLocaleString(
                                undefined,
                                {
                                  dateStyle: "long",
                                  timeStyle: "short",
                                }
                              )}
                            </p>
                          </>

                          :

                          Number(newsItem.current_price) >=
                            Number(newsItem.desired_price) ? "" :
                            <>
                              <span style={{ color: "red", fontWeight: "700" }}>
                                Desired Price Not Met Yet
                              </span>

                            </>
                      }
                    </strong>


                    {userId === newsItem.user_id && Number(newsItem.current_price) >
                      Number(newsItem.desired_price) ?
                      <strong>
                        <span style={{ fontWeight: "600", color: "green" }}>
                          Target Price Reached 😊
                        </span>
                      </strong> : ""}

                    <div style={{ fontWeight: "700", marginTop: "10px" }}>
                      {userId === newsItem.user_id &&
                        Number(newsItem.current_price) <=
                        Number(newsItem.desired_price) ? (
                        newsItem.buyer_id !== "0" && buyId?.name ? (
                          <>
                            {/* <span style={{ color: "Green", fontWeight: "700" }}>
                              * {buyId.name} buy this Product.
                            </span> */}

                            {/* {Number(newsItem.desired_price) ? (
                              <span
                                style={{ color: "Green", fontWeight: "700" }}
                              >
                                * But Desired Price Not Meet.
                              </span>
                            ) : (
                              " "
                            )} */}
                          </>
                        ) : (
                          // <span style={{ color: "red", fontWeight: "700" }}>
                          //   Desired Price Not Met
                          // </span>
                          ''
                        )
                      ) : newsItem.buyer_id !== "0" &&
                        Number(newsItem?.winner_id) != 0 &&
                        buyId?.name &&
                        newsItem.buyer_id == userId ? (
                        <>


                          <div className={`auction-status-card win`}>
                            <div className="status-icon">🏆</div>
                            <div className="status-content">
                              <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>{buyId.name} You Won this Product.</h4>
                              <p > 🎉 Congratulations 🎉 Click below.</p>
                              <Link to="/won" className="status-action">
                                Contact Seller →
                              </Link>
                            </div>
                          </div>

                          <Link to="/won" className=" contact-winner-btn">
                            Contact Seller
                            <i className="fas fa-arrow-right"></i>
                          </Link>

                        </>

                      ) : (
                        ""
                      )}

                      {userId != newsItem.buyer_id && userId == newsItem.user_id &&
                        Number(newsItem?.winner_id) != 0 &&
                        newsItem.buyer_id != "0" &&
                        buyId?.name ? (



                        <>

                          <div className={`auction-status-card win`}>
                            <div className="status-icon">🏆</div>
                            <div className="status-content">
                              <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>{buyId.name} Buy this Product.</h4>
                              <p > 🎉 Congratulations 🎉 Click below.</p>
                              <Link to="/sold" className="status-action">
                                Contact Buyer →
                              </Link>
                            </div>
                          </div>

                          <Link to="/sold" className=" contact-winner-btn">
                            Contact Buyer
                            <i className="fas fa-arrow-right"></i>
                          </Link>


                        </>

                      ) : (
                        ""
                      )}



                      {userId != newsItem.buyer_id && userId != newsItem.user_id &&
                        Number(newsItem?.winner_id) != 0 &&
                        newsItem.buyer_id != "0" &&
                        buyId?.name ? (



                        <div className={`auction-status-card win`} style={{ alignItems: "center" }}>
                          <div className="status-icon" style={{ fontSize: "20px" }}>🏆</div>
                          <div className="status-content">
                            <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>{buyId.name} Buy this Product.</h4>

                          </div>
                        </div>

                      ) : (
                        ""
                      )}

                      {Number(newsItem?.status) != 0 ? (
                        newsItem.buy_product_status == 0 &&
                          Number(newsItem?.winner_id) != 0 &&
                          Number(newsItem.current_price) >=
                          Number(newsItem.desired_price) &&
                          new Date(newsItem.closing_time) < new Date() &&
                          newsItem.winner_type != "suspended" ? (
                          (() => {
                            const match = userbid.find(
                              (bid) =>
                                Number(bid.product_id) ===
                                Number(newsItem.id) &&
                                Number(newsItem.winner_id) == Number(userId)
                            );

                            if (match) {
                              return Number(match.max_bid) >=
                                Number(match.desired_price) ? (

                                <>
                                  <div className={`auction-status-card win`}>
                                    <div className="status-icon">🏆</div>
                                    <div className="status-content">
                                      <h4>You Won This Auction!</h4>
                                      <p > 🎉 Congratulations 🎉 Click below.</p>
                                      <Link to="/won" className="status-action">
                                        Contact seller →
                                      </Link>
                                    </div>
                                  </div>


                                  <Link to="/won" className=" contact-winner-btn">
                                    Contact seller
                                    <i className="fas fa-arrow-right"></i>
                                  </Link>

                                </>

                              ) : (

                                <Link to="/lose" >
                                  <span
                                    className="allusernotify massage_link_loss animated-notify"
                                    style={{ color: "red", fontWeight: "700" }}
                                  >
                                    You Lost This Auction
                                  </span>
                                </Link>





                              );
                            } else {
                              return (
                                newsItem.user_id == userId ? (
                                  <>

                                    <div className="auction-status-card win">
                                      <div className="status-icon">🏆</div>
                                      <div className="status-content">
                                        <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                          <BuyerName buyerId={newsItem.winner_id} /> Win This Item By Auction
                                        </h4>
                                        <p>
                                          🎉 Congratulations 🎉 Click below.
                                        </p>
                                        <Link to="/sold" className="status-action">
                                          Contact Buyer →
                                        </Link>
                                      </div>
                                    </div>

                                    <Link to="/sold" className=" contact-winner-btn">
                                      Contact Buyer
                                      <i className="fas fa-arrow-right"></i>
                                    </Link>


                                  </>
                                ) : (
                                  <div className="auction-status-card win" style={{ alignItems: "center" }}>
                                    <div className="status-icon" style={{ fontSize: "20px" }}>🏆</div>
                                    <div className="status-content">
                                      <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <BuyerName buyerId={newsItem.winner_id} /> Win This Item By Auction
                                      </h4>
                                    </div>
                                  </div>
                                )
                              );

                            }
                          })()
                        ) : new Date(newsItem.closing_time) < new Date() &&
                          Number(newsItem.current_price) >=
                          Number(newsItem.desired_price) &&
                          Number(newsItem.current_price) != 0 &&
                          newsItem.buy_product_status == 0 &&
                          newsItem.winner_type != "suspended" ? (
                          <span
                            className="allusernotify"
                            style={{ color: "green", fontWeight: "700" }}
                          >
                            {Number(newsItem.winner_id) == 0 ? (
                              "Processing..."
                            ) : (
                              <>
                                🎉 <BuyerName buyerId={newsItem.winner_id} />{" "}
                                Win This Item By Auction. 🎉
                              </>
                            )}
                          </span>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                    </div>

                  </div>

                  {Number(newsItem?.status) == 0 ? (
                    <h1 className="c">This Product in Draft</h1>
                  ) : (
                    Number(newsItem.winner_id) != 0 || new Date(newsItem.closing_time) < new Date() ? ("") : (
                      <div className="coundown-area">
                        <div
                          className="countdown-container"
                          style={{ fontSize: "24px", fontWeight: "bold" }}
                        >
                          <h3>Auction Will End In:</h3>

                          <CountdownTimer closingTime={newsItem.closing_time} />

                          <p style={{ marginTop: "10px" }}>
                            <strong>Ending On:</strong>{" "}
                            {new Date(newsItem.closing_time).toLocaleString(
                              undefined,
                              {
                                dateStyle: "long",
                                timeStyle: "short",
                              }
                            )}
                            <br></br>
                            {/* {userId != newsItem.user_id &&
                            (Number(newsItem.current_price) >=
                            Number(newsItem.desired_price) ? (
                              <span
                                style={{ color: "green", fontWeight: "700" }}
                              >
                                Desired Price Met
                              </span>
                            ) : (
                              // <span style={{ color: "red", fontWeight: "700" }}>
                              //   Desired Price Not Met
                              // </span>
                              ""
                            ))} */}
                          </p>
                        </div>
                      </div>
                    )
                  )}


                  {Number(newsItem.winner_id) != 0 || new Date(newsItem.closing_time) < new Date() ? ("") : (
                    <div className="quantity-area">
                      <h6>Place Bid:</h6>
                      <div className="quantity-counter-and-btn-area">
                        <div
                          className="quantity-counter"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <button
                            className="quantity__minus"
                            onClick={handleDecrease}
                            style={{
                              cursor: "pointer",
                              fontSize: "20px",
                              border: "none",
                              background: "transparent",
                            }}
                            disabled={
                              newsItem.buy_product_status == "1" ||
                              userId === newsItem.user_id ||
                              new Date(newsItem.closing_time) < new Date()
                            }
                          >
                            <i className="bx bx-minus"></i>
                          </button>

                          <input
                            type="number" // change to text
                            className="quantity__input"
                            name="quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            style={{
                              width: "150px",
                              textAlign: "center",
                              fontSize: "18px",
                            }}
                          />

                          <button
                            className="quantity__plus"
                            onClick={handleIncrease}
                            style={{
                              cursor: "pointer",
                              fontSize: "20px",
                              border: "none",
                              background: "transparent",
                            }}
                            disabled={
                              newsItem.buy_product_status == "1" ||
                              userId === newsItem.user_id ||
                              new Date(newsItem.closing_time) < new Date()
                            }
                          >
                            <i className="bx bx-plus"></i>
                          </button>
                        </div>

                        {newsItem.buy_product_status == "1" ||
                          userId === newsItem.user_id ? (
                          <button
                            className="primary-btn btn-hover"
                            style={{
                              background: "gray",
                              cursor: "not-allowed",
                              opacity: 0.6,
                            }}
                            disabled
                          >
                            {userId === newsItem.user_id
                              ? "You Can't Bid"
                              : "Bid Closed"}
                          </button>
                        ) : new Date(newsItem.closing_time) < new Date() ? (
                          <button
                            className="primary-btn btn-hover"
                            style={{
                              background: "gray",
                              cursor: "not-allowed",
                              opacity: 0.6,
                            }}
                            disabled
                          >
                            Expired
                          </button>
                        ) : (
                          <Link
                            to="#"
                            className="primary-btn btn-hover placebid"
                            style={{
                              background:
                                "linear-gradient(to right, #f4b74d, #1692e6)",
                            }}
                            onClick={placeBid}
                          >
                            {loadingplacebid ? (
                              <span className="loader_placebid"></span> // can use CSS spinner
                            ) : (
                              "Place Bid"
                            )}
                          </Link>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="button-process">

                    {Number(newsItem.winner_id) != 0 ? ("") : (
                      newsItem.user_id === userIdLogin ? (
                        <button
                          style={{ background: "#E6AB28" }}
                          className="primary-btn btn-hover"
                          disabled
                          title="You Can't Add to your Wishlist"
                        >
                          <i
                            className={`fas ${bookmarks.some((items) => items.id === newsItem.id)
                              ? "fa-heart-broken"
                              : "fa-heart"
                              }`}
                          ></i>{" "}
                          Add to Wishlist
                        </button>
                      ) : (
                        <>
                          <Link
                            to="#"
                            className="primary-btn btn-hover"
                            style={{
                              background: "#f4b74d",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                            onClick={(e) => {
                              e.preventDefault(); // prevent default link behavior
                              bookmarks.some((items) => items.id === newsItem.id)
                                ? removefav(newsItem.id)
                                : addToFavorite(newsItem.id);
                            }}
                            title={
                              bookmarks.some((items) => items.id === newsItem.id)
                                ? "Remove from Watchlist"
                                : "Add to Watchlist"
                            }
                          >
                            <i
                              className={`fas ${bookmarks.some((items) => items.id === newsItem.id)
                                ? "fa-heart-broken"
                                : "fa-heart"
                                }`}
                            ></i>
                            {bookmarks.some((items) => items.id === newsItem.id)
                              ? "Remove from Wishlist"
                              : "Add to Watchlist"}
                          </Link>
                        </>
                      )

                    )}

                    {newsItem?.closing_time &&
                      new Date(newsItem.closing_time) < new Date() &&
                      Number(newsItem?.winner_id) === 0 &&
                      Number(newsItem?.status) != 0 && (
                        <>
                          {relistuser?.data?.some(
                            (entry) =>
                              String(entry.user_id) === String(user_id) &&
                              String(entry.product_id) === String(newsItem.id)
                          ) ? (
                            <Link
                              style={{
                                background: "rgb(59 195 14)",

                                alignItems: "center",
                                gap: "8px",
                              }}
                              className="primary-btn btn-hover"
                              title="Relist Item"
                            >
                              You applied for relist
                            </Link>
                          ) : (
                            <Link
                              onClick={() =>
                                relist(newsItem.id, newsItem.user_id)
                              }
                              style={{ background: "#1692e6" }}
                              className="primary-btn btn-hover"
                              title="Relist Item"
                            >
                              Relist Item Again
                            </Link>
                          )}
                        </>
                      )}

                    {newsItem.buy_product_status === "1" ||
                      newsItem.current_price / newsItem.buy_now >= BuyNow ||
                      newsItem.listing_type === "" ||
                      new Date(newsItem.closing_time) < new Date() ||
                      newsItem.listing_type !== "Auctionwithbuy" ? (
                      " "
                    ) : newsItem.user_id === userIdLogin ? (
                      <button
                        style={{ background: "#1692e6" }}

                        disabled
                        title="You Can't Buy Own Product"
                      >
                        Buy Now at {newsItem.buy_now} SAR
                      </button>
                    ) : (
                      <Link
                        onClick={buyitem}
                        style={{ background: "#1692e6" }}
                        className="primary-btn btn-hover"
                        title="Buy Now"
                      >
                        Buy Now at {newsItem.buy_now} SAR
                      </Link>
                    )}
                  </div>
                </div>
              )}


              <hr />

              {!showQR ? (
                <button
                  className="primary-btn btn-hover show_qr"
                  onClick={() => setShowQR(true)}
                  style={{ marginBottom: "10px" }}
                >
                  Genrate QR Code
                </button>
              ) : (
                <div
                  className="product-code"
                  style={{
                    textAlign: "center",
                    padding: "35px 12px",
                    background: "white",
                    borderRadius: "10px",
                  }}
                >
                  <p style={{ margin: "0" }}>Scan Code</p>
                  <b>Buy directly from the store</b> <br />
                  <div>
                    <div ref={qrRef}>
                      <QRCodeCanvas
                        value={`https://fasttrade.com.sa/detail/${newsItem.id}`}
                        size={128}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                        includeMargin={true}
                      />
                    </div>

                    <button
                      className="download_qr"
                      onClick={handleDownload}
                      style={{ marginTop: "10px" }}
                    >
                      ⬇️ Download QR Code
                    </button>
                  </div>
                </div>
              )}

              <div
                className="product-buyer-info"
                style={{
                  marginTop: "15px",
                  background: "white",
                  padding: "10px",
                  display: "flex",
                  gap: "10px",
                  borderRadius: "10px",
                  flexDirection: " column",
                }}
              >
                <div
                  className="product-buyer-info fontstyle2"
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => setShowUserInfo(!showUserInfo)}
                >
                  <div
                    className="img prouct_user_detail"
                    style={{ marginRight: "10px" }}
                  >
                    <Link to={`/review/${itemuserdetail.id}`}>
                      <p
                        style={{
                          padding: "10px 19px",
                          background: "whitesmoke",
                          borderRadius: "50%",
                          margin: "0px",
                          fontWeight: "700",
                          fontSize: "20px",
                        }}
                      >
                        {itemuserdetail.name?.charAt(0).toUpperCase()}
                      </p>
                    </Link>
                  </div>
                  <div className="info fontstyle2" style={{ width: "90%" }}>
                    <b>
                      <Link to={`/review/${itemuserdetail.id}`}>
                        {itemuserdetail.name}
                      </Link>
                    </b>

                    <div
                      className="prouct_user_detail2"
                      style={{
                        fontSize: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0",
                      }}
                    >
                      <UserReviewInfo userId={newsItem.user_id} />
                      <span
                        style={{
                          fontSize: "9px",
                          display: "flex",
                          gap: "5px",
                          alignItems: "end",
                        }}
                      >
                        Member since{" "}
                        {itemuserdetail?.created_date
                          ? formatDistanceToNow(
                            // Safe UTC parse
                            (() => {
                              const d = itemuserdetail.created_date;
                              if (d.endsWith("Z")) return new Date(d); // ISO UTC
                              return new Date(d.replace(" ", "T") + "Z"); // YYYY-MM-DD HH:MM:SS → UTC
                            })(),
                            { addSuffix: true }
                          ).replace("about ", "")
                          : "Date not available"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">

              <div className="askquestion">
                {newsItem.user_id === userIdLogin ? (
                  // <button title="You Can't Ask Question To own Product">
                  //   Ask any Question?
                  // </button>
                  ""
                ) : (
                  <button
                    title=" Ask Question To Product"
                    onClick={() => setShowTextarea(!showTextarea)}
                  >
                    Ask any Question?
                  </button>
                )}

                {showTextarea && (
                  <>
                    <div className="give-comment">
                      <form
                        onSubmit={questionsubmit}
                        style={{ width: "100%", position: "relative" }}
                      >
                        <textarea
                          className="form-control"
                          placeholder="Feel free to ask the seller any questions you have about this product."
                          cols="30"
                          rows="5"
                          onChange={(e) => setQuestion(e.target.value)}
                          required
                        ></textarea>

                        <div className="review-btn">
                          <input
                            type="submit"
                            value={
                              loading
                                ? "Sending..."
                                : "Ask a question to seller"
                            }
                            disabled={loading}
                            className="ask form-control mt-3"
                          />
                          <input
                            type="button"
                            value="Cancel"
                            className="cancel form-control mt-3"
                            onClick={() => setShowTextarea(!showTextarea)}
                            disabled={loading}
                          />
                        </div>

                        {/* Show loader when loading */}
                        {loading && (
                          <div
                            className="loader-overlay"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          >
                            <div className="spinner"></div>
                          </div>
                        )}
                      </form>
                    </div>
                  </>
                )}
              </div>


              <br />

              <div className="product-info">
                <div className=" btn-option">
                  <button
                    className={selectedButton === "data1" && "btn-class"}
                    onClick={() => setSelectedButton("data1")}
                  >
                    Product Description
                  </button>

                  {newsItem.product_type === "used" ? (
                    <button
                      className={selectedButton === "data3" && "btn-class"}
                      onClick={() => setSelectedButton("data3")}
                    >
                      Used Description
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    onClick={() => setSelectedButton("data2")}
                    className={`base-class ${selectedButton === "data2" ? "btn-class" : ""
                      }`}
                  >
                    Question & Answers
                  </button>
                </div>

                {selectedButton === "data1" && (
                  <div>
                    <p style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                      {newsItem?.description ? (
                        newsItem.description
                      ) : (
                        <span
                          style={{
                            display: "block",
                            textAlign: "center",
                            color: "#666",
                            padding: "20px",
                            fontStyle: "italic",
                          }}
                        >
                          Not found
                        </span>
                      )}
                    </p>

                  </div>
                )}
                {selectedButton === "data3" && (
                  <div>
                    <p style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>


                      {newsItem?.usedescription ? (
                        newsItem.usedescription
                      ) : (
                        <span
                          style={{
                            display: "block",
                            textAlign: "center",
                            color: "#666",
                            padding: "20px",
                            fontStyle: "italic",
                          }}
                        >
                          Not found
                        </span>
                      )}

                    </p>
                  </div>
                )}

                {selectedButton === "data2" && (
                  <div className="reviews_comments">
                    {loading ? (
                      <div className="userquestion">
                        {/* Show 3 skeletons */}
                        {[1, 2, 3].map((s, i) => (
                          <div
                            key={i}
                            className="questionbox skeleton"
                            style={{
                              padding: "15px",
                              background: "#f0f0f0",
                              borderRadius: "5px",
                              marginBottom: "10px",
                            }}
                          >
                            {/* Circle skeleton for BuyerNamechar */}
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                background: "#e0e0e0",
                                marginBottom: "10px",
                                animation: "pulse 1.5s infinite",
                              }}
                            ></div>

                            {/* Skeleton for Question */}
                            <div
                              style={{
                                width: "70%",
                                height: "14px",
                                background: "#e0e0e0",
                                marginBottom: "8px",
                                animation: "pulse 1.5s infinite",
                              }}
                            ></div>

                            {/* Skeleton for Answer */}
                            <div
                              style={{
                                width: "50%",
                                height: "12px",
                                background: "#e0e0e0",
                                marginBottom: "6px",
                                animation: "pulse 1.5s infinite",
                              }}
                            ></div>

                            {/* Skeleton for Date */}
                            <div
                              style={{
                                width: "30%",
                                height: "10px",
                                background: "#e0e0e0",
                                animation: "pulse 1.5s infinite",
                              }}
                            ></div>
                          </div>
                        ))}
                      </div>
                    ) : Array.isArray(questions) && questions.length > 0 ? (
                      <div className="userquestion">
                        {(() => {
                          const filteredQuestions = questions.filter((que) => {
                            const isOwner =
                              Number(que.buyer_id) === Number(userIdLogin) ||
                              Number(que.seller_id) === Number(userIdLogin);
                            const isPublic = que.type === "1";
                            return isOwner || isPublic;
                          });

                          return filteredQuestions.length > 0 ? (
                            filteredQuestions.map((que) => (
                              <div
                                key={que.id}
                                className="questionbox"
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "12px",
                                  padding: "15px",
                                  background: "#fff",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                  marginBottom: "15px",
                                }}
                              >
                                {/* Avatar */}
                                <p
                                  style={{
                                    backgroundColor: "#dddddd",
                                    padding: "10px 19px",
                                    borderRadius: "50%",
                                    margin: "0px",
                                    fontWeight: "700",
                                    fontSize: "20px",
                                  }}
                                >
                                  <BuyerNamechar buyerId={que.buyer_id} />
                                </p>

                                {/* Content */}
                                <div style={{ flex: 1 }}>
                                  <p
                                    style={{
                                      margin: "0",
                                      color: "#444",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong className="buyername">
                                      <BuyerName buyerId={que.buyer_id} />
                                    </strong>
                                  </p>
                                  <p
                                    style={{
                                      margin: "3px 0",
                                      color: "#444",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <strong>Question :</strong> {que.question}
                                  </p>

                                  {que.answer && (
                                    <p
                                      style={{
                                        margin: "3px 0",
                                        color: "#444",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <strong>Answer :</strong> {que.answer}
                                    </p>
                                  )}

                                  {/* Reply button (only for seller) */}
                                  {Number(que.seller_id) ===
                                    Number(userIdLogin) &&
                                    activeReplyId !== que.id && (
                                      <button
                                        style={{
                                          marginTop: "5px",
                                          fontSize: "12px",
                                          padding: "1px 10px",
                                          borderRadius: "4px",
                                          border: "2px solid rgb(134 134 134)",
                                          background: "rgb(245 245 245 / 0%)",
                                          cursor: "pointer",
                                          fontWeight: "700",
                                        }}
                                        onClick={() => setActiveReplyId(que.id)} // sirf true/false
                                      >
                                        Reply
                                      </button>
                                    )}

                                  {/* Reply input box */}
                                  {activeReplyId === que.id ? (
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        display: "flex",
                                        gap: "5px",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        value={replyText}
                                        onChange={(e) =>
                                          setReplyText(e.target.value)
                                        }
                                        placeholder=" Type your reply..."
                                        style={{
                                          padding: "6px",
                                          fontSize: "13px",
                                          width: "80%",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                          marginRight: "6px",
                                          fontWeight: "600",
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          handleReplySubmit(que.id)
                                        }
                                        style={{
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "none",
                                          background: "#007bff",
                                          color: "#fff",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          minWidth: "40px",
                                        }}
                                        disabled={showReplyLoading} // disable while loading
                                      >
                                        {showReplyLoading ? (
                                          <i className="fas fa-spinner fa-spin"></i> // loader spinner
                                        ) : (
                                          <i className="fas fa-paper-plane"></i> // normal send icon
                                        )}
                                      </button>

                                      <button
                                        onClick={handleCancel}
                                        style={{
                                          fontSize: "25px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                          background: "#f5f5f5",
                                          color: "#333",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <i className="fas fa-times"></i>
                                      </button>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>

                                {/* Time */}
                                <p
                                  style={{
                                    margin: "0",
                                    fontSize: "13px",
                                    color: "#888",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {formatDistanceToNow(
                                    (() => {
                                      const d = que.question_date;
                                      if (!d) return new Date();
                                      if (d.endsWith("Z")) return new Date(d);
                                      return new Date(
                                        d.replace(" ", "T") + "Z"
                                      );
                                    })(),
                                    { addSuffix: true }
                                  ).replace("about ", "")}
                                </p>
                              </div>
                            ))
                          ) : (
                            <p
                              style={{
                                textAlign: "center",
                                color: "#666",
                                padding: "20px",
                                fontStyle: "italic",
                              }}
                            >
                              No questions found
                            </p>
                          );
                        })()}
                      </div>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          color: "#666",
                          padding: "20px",
                          fontStyle: "italic",
                        }}
                      >
                        No questions found
                      </p>
                    )}
                    <style>
                      {`
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
`}
                    </style>
                  </div>
                )}
              </div>

              <br />

              <hr />

              <div className="shippiing-details">
                <h2>Shipping & Location</h2>

                <div className="shippiing-info">
                  <table className="table">
                    {/* <thead>
                      <tr>
                        <th scope="col">Location</th>
                      </tr>
                    </thead> */}
                    <tbody>
                      <tr>
                        <td>
                          {newsItem.neighborhood
                            ? `${newsItem.neighborhood},`
                            : ""}
                          {newsItem.location
                            ? ` ${newsItem.location}, Saudi Arabia`
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Shipping :{" "}
                          {newsItem.shipping == "No"
                            ? "Not Available "
                            : "Available"}{" "}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>

      <div className="latest-auction-section mb-110">
        <div className="container">
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <h2>
                  Related <span>Auction</span>
                </h2>
                <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p>
              </div>
            </div>
          </div>
          <div className="row g-4 related_products">
            {loading ? (
              [...Array(4)].map((_, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div className="auction-card-img-wrap">
                      <div className="card-img">
                        <Skeleton height={200} />
                      </div>
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Skeleton width={`80%`} />
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <Skeleton width={100} />
                        </div>
                        <div className="code">
                          <Skeleton width={50} />
                        </div>
                      </div>
                      <div className="author-and-btn-area">
                        <div className="author-area d-flex align-items-center">
                          <Skeleton circle height={40} width={40} />
                          <Skeleton width={100} style={{ marginLeft: 10 }} />
                        </div>
                        <div className="bid-btn">
                          <Skeleton width={80} height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={10}
                slidesPerView={4}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                // autoplay={{ delay: 2500, disableOnInteraction: false }}
                loop={false}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  348: { slidesPerView: 2 },
                  458: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {NewADD.slice(0, 10).map((item, index) => (
                  <SwiperSlide key={item.id}>
                    <div
                      className="auction-card wow animate "
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <div
                        className="auction-card-img-wrap"
                        style={{ position: "relative", overflow: "hidden" }}
                      >
                        <Link to={`/detail/${item.id}`} className="card-img">
                          <img
                            src={
                              item.photo
                                ? `${BASE_URL}/${item.photo
                                  .split(",")[0]
                                  .trim()}`
                                : `${BASE_URL}/uploads/logo/icon.png`
                            }
                            alt=""
                          />
                        </Link>
                        <ul className="bookmark_icon">
                          <li>
                            {favloading[item.id] ? (
                              <span className="fav-spinner"></span>
                            ) : (
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault(); // 🛑 Stop navigation
                                  bookmarks.some((b) => b.id === item.id)
                                    ? removefav(item.id)
                                    : addToFavorite(item.id);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faHeart}
                                  style={{
                                    color: bookmarks.some(
                                      (b) => b.id === item.id
                                    )
                                      ? "#F2B42A"
                                      : "",
                                    borderRadius: "50%",
                                  }}
                                />
                              </Link>
                            )}
                          </li>
                        </ul>

                        {item.membership_type !== "Basic" && (
                          <p
                            className="tag"
                            style={{
                              position: "absolute",
                              top: 15,
                              left: "-23px",
                              margin: 0,
                              background:
                                item.membership_type === "Gold"
                                  ? "#F2B42A"
                                  : item.membership_type === "Silver"
                                    ? "#C0C0C0"
                                    : "#ffffff", // fallback
                              padding: "0px 22px",
                              textAlign: "center",
                              borderRadius: "2px",
                              color: "black",
                              fontWeight: 800,
                              transform: "rotate(309deg)"
                            }}
                          >
                            {item.membership_type}
                          </p>
                        )}
                        <CountdownTimer closingTime={item.closing_time} />
                      </div>
                      <div className="auction-card-content">
                        <div
                          className="price-and-code-area"
                          style={{ marginBottom: "5px" }}
                        >
                          <div className="price">
                            <span
                              style={{
                                fontSize: "15px",
                                color: "#91948F",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "1px",
                              }}
                            >
                              <FaMapMarkerAlt
                                style={{ color: "#91948F", fontSize: "14px" }}
                              />{" "}
                              {item.city?.length > 15
                                ? item.city.substring(0, 15) + "..."
                                : item.city}
                            </span>
                          </div>
                          <div className="code"># {item.id}</div>
                        </div>
                        <h6 className="product_title">
                          {item.title ||
                            "Vintage valor embracing the elegance of eras past."}

                        </h6>

                        <div className="price-and-code-area">
                          <div className="price">
                            <span>Current Bid at:</span>
                            <strong>
                              {item.current_price === ""
                                ? item.auction_start_price
                                : item.current_price}{" "}
                              SAR
                            </strong>
                          </div>

                          {Number(item.current_price) / Number(item.buy_now) >=
                            buyNowLimit ? (
                            ""
                          ) : Number(item.buy_now) == 0 ? (
                            ""
                          ) : (
                            <div className="price">
                              <span>Buy Now at:</span>
                              <strong>{Number(item.buy_now)} SAR</strong>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "8px",
              width: "400px",
              maxWidth: "90%",
              boxShadow: "0 0 10px rgba(0,0,0,0.25)",
            }}
          >
            <h3>Rate Seller</h3>
            <h5 style={{ fontSize: "14px", color: "#888", display: "none" }}>
              Buyer ID: {selectedBuyerId}
            </h5>

            <div style={{ marginBottom: "15px" }}>
              <p
                style={{
                  marginBottom: "8px",
                  color: "black",
                  fontWeight: "600",
                }}
              >
                What is your level of satisfaction?
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "center",
                  fontSize: "32px",
                }}
              >
                {[
                  {
                    label: "sad",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji.sad_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                  {
                    label: "neutral",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji.natural_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                  {
                    label: "happy",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji.happy_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                ].map((option) => (
                  <span
                    key={option.label}
                    onClick={() => setSatisfactionLevel(option.label)}
                    className="rating_emoji"
                    style={{
                      border:
                        satisfactionLevel === option.label
                          ? "3px solid #007bff"
                          : "3px solid transparent",
                    }}
                    title={option.label}
                  >
                    {option.emoji}
                  </span>
                ))}
              </div>
            </div>

            <textarea
              rows="4"
              value={ratingText}
              onChange={(e) => {
                setRatingText(e.target.value);
                setBadWordError("");
              }}
              className={badWordError ? "textarea-error " : ""}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
              }}
              placeholder="Write your feedback here..."
            ></textarea>

            {badWordError && (
              <div
                style={{ color: "red", marginBottom: "5px", fontSize: "12px" }}
              >
                {badWordError}
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={handleSubmitRating}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  width: "50%",
                }}
              >
                Submit
              </button>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  width: "50%",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}
      <Fotter />
      <ToastContainer />
    </>
  );
}
